import classNames from 'classnames';
import omit from 'lodash/omit';
import React from 'react';
import { useGlobalKeys, useOuterClick } from '../../../../hooks';
import { ODArrow } from '../../../../icons';
import { ODAppBarThemeType, } from '../../../../interfaces';
import { useGlobalContext } from '../../../global';
import { Hoverable, HoverableButton } from '../../../styled';
import { useGNBContext } from '../../ODGNBProvider';
export var ODGNBDropdownMenu = function (props) {
    var _a = props.def, text = _a.text, subMenus = _a.subMenus, className = _a.className;
    var convertThemeString = useGlobalContext().convertThemeString;
    var _b = useGNBContext(), _c = _b.state.def, position = _c.position, theme = _c.theme, textColor = _c.textColor, factory = _b.factory;
    var _d = React.useState(false), open = _d[0], setOpen = _d[1];
    var ref = useOuterClick(function () { return setOpen(false); });
    var toggle = function () { return setOpen(function (v) { return !v; }); };
    var topBar = position === 'top';
    var sideBar = position === 'side';
    var isCui = theme.type === ODAppBarThemeType.CoreUILike;
    var cuiTheme = theme;
    var menuClassName = classNames({ hidden: !open }, 'od-gnb-dropdown menu-outer', theme.type);
    var menuStyleTop = omit({
        minWidth: isCui ? '250px' : undefined,
        borderRadius: isCui ? '3px' : undefined,
        border: isCui ? convertThemeString('1px solid {{gray300}}') : undefined,
    });
    var menuStyleSide = omit({
        minWidth: isCui ? '250px' : undefined,
        borderRadius: isCui ? 0 : undefined,
    });
    var buttonClassName = classNames({
        'md:w-auto md:inline md:mt-0 md:ml-4': topBar,
        'md:block': sideBar,
        'rounded-lg': !isCui,
        'hover:bg-gray-200': !isCui,
    }, 'flex flex-row items-center w-full px-4 py-2 mt-2 text-sm font-semibold text-left bg-transparent focus:outline-none focus:shadow-outline');
    var buttonStyle = omit({
        borderRadius: isCui ? cuiTheme.topItemRadius : undefined,
        color: textColor,
    });
    var globalKeys = useGlobalKeys(function () { return subMenus.map(function (m) { return m.globalKey; }); });
    var hoverColor = isCui ? convertThemeString(cuiTheme.hoverColor) : undefined;
    var hoverDropdownColor = isCui ? convertThemeString(cuiTheme.hoverColorDropdown) : undefined;
    var dropDownHoverableStyle = omit({
        borderRadius: isCui && sideBar ? 0 : undefined,
    });
    return (React.createElement("div", { ref: ref, className: classNames('od-gnb-dropdown', className) },
        React.createElement(HoverableButton, { onClick: toggle, className: buttonClassName, style: buttonStyle, hoverColor: hoverColor },
            React.createElement("span", null, text),
            React.createElement(ODArrow, { open: open })),
        React.createElement("div", { className: menuClassName, style: sideBar ? menuStyleSide : menuStyleTop },
            React.createElement(Hoverable, { className: "od-gnb-dropdown menu-inner border-none", hoverColor: hoverDropdownColor, style: dropDownHoverableStyle }, subMenus.map(function (menu, index) {
                return factory.renderMenuItem(globalKeys[index], menu, true);
            })))));
};
//# sourceMappingURL=ODGNBDropdownMenu.js.map